import type {
    AdminDashboardParams,
    AdminDashboardSummaryResponse,
    DashboardParams,
    DashboardSummaryResponse,
} from '@/types';
import type { AxiosInstance, AxiosResponse } from 'axios';

class DashboardService {
    private readonly apiService;

    constructor(apiService: AxiosInstance) {
        this.apiService = apiService;
    }

    summary(params: DashboardParams): Promise<AxiosResponse<DashboardSummaryResponse>> {
        return this.apiService.get('/api/dashboard/summary', { params });
    }

    /** Product metrics across every tenant; admin-only (MILO-141). */
    adminSummary(params: AdminDashboardParams = {}): Promise<AxiosResponse<AdminDashboardSummaryResponse>> {
        return this.apiService.get('/api/admin/dashboard/summary', { params });
    }
}

export default DashboardService;
